import { Inject, Injectable } from '@angular/core';
import { APPLICATION_NAME_TOKEN } from '@ddt-web/config';
import { contentConfigFetched, PcConfigKey, SharedConfigKey } from '@ddt-web/config-layer';
import { ApplicationNames } from '@ddt-web/domain';
import { APPLICATION_TO_PREFERENCE_KEY_MAP, USER_PREFERENCES_PROPERTIES, UserPreferencesProps } from '@ddt-web/user-data';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as get from 'lodash/get';
import { tap } from 'rxjs/operators';

import { DataUserDataService } from '../api/data-user-data.service';
import { UserPreferencesConfig } from './store.config';

@Injectable()
export class UserPreferencesEffects {
	constructor(
		private actions$: Actions,
		private dataUserDataService: DataUserDataService,
		@Inject(APPLICATION_NAME_TOKEN) private applicationName: keyof ApplicationNames
	) { }

	public fetchUserPreferences$ = createEffect(() =>
		this.actions$.pipe(
			ofType(contentConfigFetched),
			tap(({ contentConfig }) =>
				this.dataUserDataService.fetchUserDataPreference(
					[UserPreferencesConfig.userPreferences],
					APPLICATION_TO_PREFERENCE_KEY_MAP.get(this.applicationName),
					USER_PREFERENCES_PROPERTIES,
					true,
					{
						[UserPreferencesProps.CURRENCY]: get(contentConfig, SharedConfigKey.PC_CURRENCY_SELECTION_OPTIONS)?.split(',')[0],
						[UserPreferencesProps.BENCHMARK]: get(contentConfig, PcConfigKey.PC_BENCHMARK_SELECTION_OPTIONS)?.split(',')[0]
					}
				)
			)
		), { dispatch: false }
	);
}
